<template>
  <div class="competition-charts">
    <div class="charts-header" v-if="chartsListData.chartsList.length>0" :style='{border:headBorder==="false"?"none":""}'>
      <span :style="{width:firstWidth?firstWidth:'25%'}">{{firstLi?firstLi:$t('dc_lang.排名')}}</span>
      <span :style="{width: secondWidth?secondWidth:'35%'}">{{sedLi?sedLi:'团队'}}</span>
      <div class="lastLi" :style="{width: thirdWidth?thirdWidth:'25%'}">
        {{lastLi?lastLi:'最高分'}}
        <div v-if='url'  :to='url' class="question">
          <img src='/static/img/common/question-mark.png'>
        </div>
      </div>
    </div>
    <template v-if="chartsListData.currentTeamRank&&chartsListData.currentTeamRank.length>0">
      <div  class="charts-body" :to="{path:'/team-homepage',query:{teamId:chartsListData.currentTeamRank[0].id}}">
        <div class="charts-ranking"  :style="{width: firstWidth?firstWidth:'25%'}">
          <span> 我的排名:{{chartsListData.currentTeamRank[0].rank}}</span>
        </div>
        <div class="ranking-team"  :style="{width: secondWidth?secondWidth:'35%'}">
          <div class='ranking-team-avatar'>
            <img :src='chartsListData.currentTeamRank[0].avatar' :onerror="errorImg(chartsListData.currentTeamRank[0].id)">
          </div>
          <span>{{chartsListData.currentTeamRank[0].name}}</span>
        </div>
        <div class="highest-score"  :style="{width: thirdWidth?thirdWidth:'25%'}">
          <span>{{chartsListData.currentTeamRank[0].publicScore}}</span>
        </div>
      </div>
    </template>

    <template v-for="(item,index) in chartsListData.chartsList">
      <div class="charts-body" v-if='barUrl===""' :style='{borderBottom:index===chartsListData.chartsList.length-1?"none;":"1px solid rgba(0,0,0,0.08);"}'>
        <div class="charts-ranking" :style="{width: firstWidth?firstWidth:'25%'}">
          <img class='image' src="/static/img/competition-ranking/gold@2x.png" v-if="index===0">
          <img class='image' src="/static/img/competition-ranking/silver@2x.png" v-else-if="index===1">
          <img class='image' src="/static/img/competition-ranking/bronze@2x.png" v-else-if="index===2">
          <span v-else class="ranking-number">{{index+1}}</span>
        </div>
        <!-- 名人堂 -->
        <template v-if='page==="famousHall"'>
          <div  :to="{path:'/myIndex/1/'+item.id}" class="ranking-team"  :style="{width:secondWidth?secondWidth:'35%'}">
            <div class='ranking-team-avatar'>
              <img :src='item.avatar===null?"":item.avatar' :onerror="errorImg(item.id)">
            </div>
            <span>{{item.username}}</span>
          </div>
          <div class="highest-score" :style="{width:thirdWidth?thirdWidth:'25%'}">
            <span>{{common.mathRound(item.points)}}</span>
          </div>
        </template>

         <!--年度英雄榜-->
        <template v-else-if='page==="heroLegends"'>
          <div  :to="{path:'/myIndex/1/'+item.user_id}" class="ranking-team" :style="{width:secondWidth?secondWidth:'35%'}">
            <div class='ranking-team-avatar'>
              <img :onerror="errorImg(item.user_id)"  :src='item.avatar===null?"":item.avatar'>
            </div>
            <span>{{item.username}}</span>
          </div>
          <div class="highest-score" :style="{width:thirdWidth?thirdWidth:'25%'}">
            <span>{{common.ceil(item.points)}}</span>
          </div>
        </template>
         <!--历史月top3-->
        <template v-else-if='page==="monthTop3"'>
          <div  :to="{path:'/myIndex/1/'+item.user_id}" class="ranking-team" :style="{width:secondWidth?secondWidth:'35%'}">
            <div class='ranking-team-avatar'>
              <img :onerror="errorImg(item.user_id)"  :src='item.avatar===null?"":item.avatar'>
            </div>
            <span>{{item.username}}</span>
          </div>
          <div class="highest-score" :style="{width: thirdWidth?thirdWidth:'25%'}">
            <span style='color:#FF7E00;'>+{{common.mathRound(item.points_offset)}}</span>
          </div>
        </template>
        <!-- 默认 -->
        <template v-else>
          <div  :to="{path:'/myIndex/1/'+item.id}" class="ranking-team" :style="{width: secondWidth?secondWidth:'35%'}">
            <div class='ranking-team-avatar'>
              <img :onerror="errorImg(item.id)"   :src='item.avatar===null?"":item.avatar'>
            </div>
            <span>{{item.teamName}}</span>
          </div>
          <div class="highest-score" :style="{width:thirdWidth?thirdWidth:'25%'}">
            <span>{{item.publicScore}}</span>
          </div>
        </template>
      </div>
      <!--队伍排行榜-->
      <div v-else  class="charts-body" :to="{path:'/team-homepage',query:{teamId:item.id}}">
        <div class="charts-ranking" :style="{width: firstWidth?firstWidth:'25%'}">
          <img class='image' src="/static/img/competition-ranking/gold@2x.png" v-if="index===0">
          <img class='image' src="/static/img/competition-ranking/silver@2x.png" v-else-if="index===1">
          <img class='image' src="/static/img/competition-ranking/bronze@2x.png" v-else-if="index===2">
          <span v-else class="ranking-number">{{index+1}}</span>
        </div>
        <div  class="ranking-team" :style="{width:secondWidth?secondWidth:'35%'}">
          <div class='ranking-team-avatar'>
            <img :src='item.avatar===null?"":item.avatar' :onerror="errorImg(item.id)">
          </div>
          <span>{{item.name}}</span>
        </div>
        <div v-if="lastLi==='状态'" class="highest-score"  :style="{width:thirdWidth?thirdWidth:'25%'}">
          <span>{{item.status}}</span>
        </div>
        <div v-else class="highest-score" :style="{width:thirdWidth?thirdWidth:'25%'}">
          <span>{{item.publicScore}}</span>
        </div>
      </div>
    </template>

  </div>
</template>

<script>

export default {
  name: 'competition-ranking-list',

  props: {
    chartsListData: {
      type: Object
    },
    headBorder: {
      type: Boolean
    },
    url: {
      type: String
    },
    page: {
      type: String
    },
    lastLi: {
      type: String
    },
    requestBool: {
      type: Boolean
    },
    firstWidth: {
      type: String
    },
    secondWidth: {
      type: String
    },
    thirdWidth: {
      type: String
    },
    firstLi: {
      type: String
    },
    sedLi: {
      type: String
    },
    thirdLi: {
      type: String
    },
    barUrl: {
      type: String
    }
  },
  data () {
    return {}
  },
  methods: {
    errorImg: function (id) {
      return 'this.src=' + '"' + this.common.errorImg(id) + '"'
    }
  }
}
</script>

<style scoped>
  .charts-header,.charts-body{
    height: 98px;
    padding: 0 40px 0 10px;
    display: flex;
    justify-content: space-between;
    background-color: #ffffff;
    align-items: center;
    border-bottom: 2px solid rgba(0,0,0,0.08);
    text-align: center;
    box-sizing: border-box;
  }
  .lastLi{
    /*font-weight:bold;*/
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .question{
    padding-top: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .question img{
    width: 30px;
    margin-left: 6px;
  }
  .mine-charts-body{
    height: 95px;
    padding: 0 40px 0 10px;
    display: flex;
    justify-content: space-between;
    background-color: #ffffff;
    align-items: center;
    border-bottom: 1px solid rgba(0,0,0,0.08);
    text-align: center;
  }
  .mine-charts-body span{
    font-size: 28px;/*px*/
    color: #17171A;
    line-height: 46px;
  }
  .charts-header{
    font-size: 32px;
    color: #17171A;
  }

  .charts-body .image{
    width: 38px;
    height: 48px;
  }
  .charts-body span{
    font-size: 28px;/*px*/
    color: #17171A;
    line-height: 46px;
  }
  .charts-ranking{
    /*去掉加载图片出现的空白*/
    font-size: 0;
    /*font-size: 28px;!*px*!*/
  }
  .ranking-team{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    text-align: left;
    padding-left:30px
  }

  .ranking-team span{
    flex:1;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap
  }
  .ranking-team .ranking-team-avatar{
    width: 60px;
    height: 58px;
    margin-right: 10px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid rgba(0,0,0,0.08);
    box-sizing: border-box;
    background: #fff;
  }
  .ranking-team-avatar img{
    max-width: 100%;
    max-height: 100%;
  }
  /*.content-empty{*/
    /*padding-bottom:130px;*/
    /*background:#fff;*/
    /*display:flex;*/
    /*flex-direction:column;*/
    /*align-items:center;*/
    /*box-sizing:border-box;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/competition/competition-ranking-list/competition-ranking-list.vue